import { render } from "./AppSnackbar.vue?vue&type=template&id=5d756280&scoped=true"
import script from "./AppSnackbar.vue?vue&type=script&lang=js"
export * from "./AppSnackbar.vue?vue&type=script&lang=js"

import "./AppSnackbar.vue?vue&type=style&index=0&id=5d756280&scoped=true&lang=css"
import "./AppSnackbar.vue?vue&type=style&index=1&id=5d756280&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d756280"]])

export default __exports__